export default __webpack_public_path__ + "static/media/delta-motorsport.75326527.png";